






























import { Vue, Component, Prop } from "vue-property-decorator";
import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";

import TypeItem from "./components/EventTypeItem.vue"

@Component({ components: { TypeItem } })

export default class EventTypeSelectPanel extends Vue {

    @Prop() mods: ('dashed' | 'with-plus')[] | undefined;

    OnlineProvider = OnlineProvider;

    toCreate(type: OnlineProvider) {
        this.$router.push({
            name: RouteNamesEnum.sessionCreate,
            params: {
                sessionType: type,
                eventId: this.$route.params.eventId,
                backend: this.$route.params.backend
            }
        })
        .then(() => { this.$emit('close') })
        .catch((r) => {r})
    }

    get modsClassname() {
        return this.mods?.map((mod) => `event-type-select-panel_${mod}`).join(' ')
    }
}

